import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { RenderModalFunctionParams, WithModal } from "@amzn/stencil-react-components/modal";
import { getString } from "common/uistringlabels/uiStringUtils";
import { Visibility } from "lib/models/list-models";
import React from "react";

import ListModal from "./ListModal";

interface ListModalButtonProps {
  initialData?: { name?: string; description?: string; visibility?: Visibility; allowedDomains?: string[] };
  listId?: string;
  isEdit?: boolean;
  buttonText?: string;
  variant?: ButtonVariant;
}

const ListModalButton: React.FC<ListModalButtonProps> = ({
  initialData,
  listId,
  isEdit = false,
  buttonText,
  variant = ButtonVariant.Primary,
}) => {
  const renderModal = ({ close }: RenderModalFunctionParams) => (
    <ListModal onClose={close} initialData={initialData} listId={listId} isEdit={isEdit} />
  );

  return (
    <WithModal renderModal={renderModal}>
      {({ open }) => (
        <Button variant={variant} onClick={open}>
          {buttonText || getString(isEdit ? "lists.editList" : "lists.createList")}
        </Button>
      )}
    </WithModal>
  );
};

export default ListModalButton;
